<template>
    <div class="page" style="margin: 0 -.5rem;">
        <!-- <answer-header type="back"></answer-header> -->
        <img class="logo" src="../assets/logo.png">
        <div class="rank-mod" style="margin-top: -0.4rem;">
            <!-- <div class="btn btn-sm" @click="_goRank">ေရာက္ရွိအဆင့္: {{ranking}}</div> -->

            <div class="menu" @click="_gotoMenu">
              <img width="40" src="../assets/memu.png" />
            </div>
<!--            <div class="btn-sm" @click="_showShare">-->
<!--              <img width="40" src="../assets/share.png" />-->
<!--            </div>-->
        </div>
        <div class="content mt20">
          <div class="" @click="_gotoDoclist">
            <img width="100%" src="../assets/img1.png" />
          </div>
        </div>
        <div class="content rank-mod mt20">
          <div class="" style="width: 49%;" @click="_goStore">
            <img width="100%" src="../assets/img2.png" />
          </div>
          <div class="" style="width: 49%;" @click="_gotoComeSoon">
            <img width="100%" src="../assets/img3.png" />
          </div>
        </div>
        <div class="btn mt20 btn-blue btn-block flex-item-block">
            <span class="">ဖုန်းနံပါတ်: {{mobile}}</span>
        </div>
        <div class="btn mt20 btn-blue btn-block flex-item-block" @click="_goStore">ဖြေဆိုရန် {{count}} Quest</div>
        <mt-popup v-model="showSharePop" position="bottom" class='sharePop'>
            <social-sharing v-bind:url="shareUrl" v-bind:title="shareTitle" v-bind:description="shareDesc" v-bind:quote="shareDesc" hashtags="答题,抽奖" twitter-user="vuejs" inline-template>
                <div>
                    <ul class='share-list'>
                        <li class='share-item'>
                            <network network="facebook">
                                <i class="fa fa-facebook"></i> Facebook
                            </network>
                        </li>
                        <li class='share-item'>
                            <network network="googleplus">
                                <i class="fa fa-google-plus"></i> Google +
                            </network>
                        </li>
                        <li class='share-item'>
                            <network network="linkedin">
                                <i class="fa fa-linkedin"></i> LinkedIn
                            </network>
                        </li>
                        <li class='share-item'>
                            <network network="twitter">
                                <i class="fa fa-twitter"></i> Twitter
                            </network>
                        </li>
                        <li class='share-item'>
                            <network network="vk">
                                <i class="fa fa-vk"></i> VKontakte
                            </network>
                        </li>
                        <li class='share-item'>
                            <network network="whatsapp">
                                <i class="fa fa-whatsapp"></i> Whatsapp
                            </network>
                        </li>
                    </ul>
                </div>
            </social-sharing>
        </mt-popup>

        <div class="modal" v-if="showLoad">
          <div class="modal-bg"></div>
          <div class="modal-content" style="width:100%;left:0;">
            <div class="loadBox ac">
              <div class="load-bg"></div>
              <div class="loadCont" style="text-align: center;">
                <img src="../assets/loading.gif"/>
                <div class="p">loading ...</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import answerHeader from './Header'
import question from './Question'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Ucenter',
    components: {answerHeader, question},
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],
            showLoad:false,
            showSharePop: false,
            shareUrl: 'http://qs.wobangta.com/#/share',
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id,
            loaded: false,
            count: 0
        }
    },
    computed: {
        ...mapState(['lang','langMap'])
    },
    created(){
        if(this.$route.query.msisdn){
          this.showLoad = true
          setTimeout(() => {
            this._loginAction();
          }, 3000);
        }else{
          this._fetchUserInfo();
          this._fetchRankList();
        }
    },
    methods: {
        _fetchRankList(){
            Utils.$ajax({
                url: '/core/rank/&page_id=1&page_size=3',
            }).done(res=>{
                if(res.code!=0){
                    //console.log(res);
                    //this.$toast(res.msg);
                    return;
                }
                this.list = res.data.list;
            });
        },
        _fetchUserInfo(){
            let that = this;
            Utils.$ajax({
                url: '/user/info',
            }).done(res=>{
                if(res.code == 4401){
                  that.$router.push(`/login`);
                }
                if(res.code!=0){
                    return;
                }
                this.loaded = true;
                this.count = res.data.question_count;
                this.score = res.data.score;
                this.mobile = res.data.mobile;
                this.name = res.data.name;
                this.ranking = res.data.ranking;
                this.id = res.data.uuid;
            });
        },
        _loginAction(){
          let reqData = {mobile: this.$route.query.msisdn, password: this.passwd}
          Utils.$ajax({
            type: 'post',
            url: '/login/login',
            data: reqData,
          }).done(res=>{
            this.showLoad = false;
            if(res.code==0){
              localStorage.A_uuid = res.data.uuid;
              localStorage.A_token = res.data.token;
              localStorage.A_mobile = res.data.mobile;
              this._fetchUserInfo();
              this._fetchRankList();
            }else if(res.code==4401){
              // window.location.href = "https://gt.questtomio.com/consent/page";
              this.$router.push(`/login`);
            }else{
              this.$toast(res.msg);
            }
          })
        },
        _startAn(){
            this.$router.push(`/answer`);
        },
        _goStore(){
            this.$router.push('/store');
        },
        _goRank(){
            this.$router.push('/rank')
        },
        _gotoDoclist(){
            this.$router.push('/doclist')
        },
        _gotoMenu(){
            this.$router.push('/menu')
        },
        _gotoComeSoon(){
            this.$router.push('/comingsoon')
        },
        _showShare() {
            Utils.$ajax({
                type: 'get',
                url: '/share/home'
            }).done(res=>{
                if(res.code != 0) return;
                this.showSharePop = true;
                this.shareTitle = res.data.title;
                this.shareDesc = res.data.desc;
                this.shareUrl = res.data.link;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        color: #fff;
    }
    .id{
        font-weight: bold;
        font-size: rem(40);
        text-shadow: 0 0 5px rgba(0,0,0,.6);
    }
    .score-line{
        display: flex;
        justify-content: space-around;
        em{
            text-decoration: underline;
            color: #000;
        }
    }
    .divider{
        width: 100%;
        height: 0;
        border-top: 1px dashed #000;
        margin: rem(30) auto;
    }
    .list{
        .item{
            text-align: center;
            margin: rem(20) auto;
            display: flex;
            justify-content: space-between;
            i{
                display: inline-block;
                width: rem(40);
                height: rem(40);
                border-radius: 50%;
                background-color: #c37600;
                color: #fff;
                line-height: rem(40);
                text-align: center;
                margin-right: rem(6);
            }
        }
    }
    .rank-mod{
        margin-top: rem(10);
        display: flex;
        justify-content: space-between;
    }
    .menu{

        // position: absolute;
        // top: rem(50);
        // right: rem(50);
        // font-family: 'Arial black';
        // font-size: rem(35);
        // color: #000;
        // font-weight: bold;
        // border-top: 3px #000 solid;
        // border-bottom: 3px #000 solid;
    }



.que1-mod {
    margin-top: rem(30);
    height: rem(180);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    color: #000;
}

.que2-mod {
    margin-top: rem(30);
    height: rem(180);
    text-align: center;
    color: #000;

    p {
        line-height: 2em;
    }

    .no-ques{
        display: flex;
        justify-content: space-around;
        margin-bottom: rem(30);
    }
}

	.modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
	.modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
	.modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);}
	.loadCont .p{color:#fff;margin:10px 0 0;}
  .btn.btn-blue{
        background-color: #f3f3f3;
        color: #1f7fc3;
        border: 1px solid #1f7fc3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ucenter.vue